import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import NavDateRangeDialog from './NavDateRangeDialog';
import NavGrouping from './NavGrouping';
import classNames from 'classnames';
import Button from 'material-ui/Button';
import NavSamplesAction from '../../container/nav/NavSamplesAction';

const styles = {
  samplesControlsBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid rgba(0,0,0,.1)',
    paddingBottom: '.5rem',
    margin: '0 auto .5rem'
  },

  samplesControlsBarAlignedRight: {
    justifyContent: 'flex-end'
  },

  samplesControlsElements: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
};

const NavGoBackButton = ({ isSankeyChildTemplate, goBack }) => {
  if (isSankeyChildTemplate) {
    return (
      <Button raised color="primary" onClick={goBack}>
        Go back
      </Button>
    );
  }

  return null;
};

const NavGroupingBar = ({
  isChartTemplate,
  isExternalTemplate,
  isSankeyChildTemplate
}) => {
  if (isChartTemplate && !isExternalTemplate && !isSankeyChildTemplate) {
    return <NavGrouping />;
  }

  return null;
};

const SamplesControlsBar = ({
  classes,
  queryParams,
  isChartTemplate,
  updateQueryParams,
  updateAggregationLevel,
  updateQueryAggregationLevel,
  timezone,
  pageType,
  NavChartOptions,
  NavSankeyOptions,
  loading,
  history,
  isExternalTemplate,
  isSankeyChildTemplate,
  goBack
}) => (
  <div
    className={
      isChartTemplate || isSankeyChildTemplate
        ? classes.samplesControlsBar
        : classNames(
            classes.samplesControlsBar,
            classes.samplesControlsBarAlignedRight
          )
    }
  >
    {NavGroupingBar({
      isChartTemplate,
      isExternalTemplate,
      isSankeyChildTemplate
    })}
    {NavGoBackButton({ isSankeyChildTemplate, goBack })}

    <div className={classes.samplesControlsElements}>
      {pageType === 'chart' && !isSankeyChildTemplate ? NavChartOptions : null}
      {pageType === 'sankey' ? NavSankeyOptions : null}

      <NavSamplesAction pageType={pageType} />

      <NavDateRangeDialog
        queryParams={queryParams}
        updateQueryParams={updateQueryParams}
        updateQueryAggregationLevel={updateQueryAggregationLevel}
        timezone={timezone}
        pageType={pageType}
        loading={loading}
      />
    </div>
  </div>
);

SamplesControlsBar.propTypes = {
  queryParams: PropTypes.object.isRequired,
  updateQueryParams: PropTypes.func.isRequired,
  timezone: PropTypes.string,
  pageType: PropTypes.string,
  NavChartOptions: PropTypes.object,
  NavSankeyOptions: PropTypes.object,
  loading: PropTypes.bool,
  external: PropTypes.bool
};

export default withStyles(styles, { name: 'SamplesControlsBar' })(
  SamplesControlsBar
);



// WEBPACK FOOTER //
// ./src/components/nav/NavSamplesBar.js